import { Info } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Motion";
import { PageHeader, CtaBand } from "../components/Detail";

export default function Pricing() {
  const { t } = useLanguage();
  const p = t.pricing;
  return (
    <main id="main-content">
      <PageHeader overline={p.pageOverline} title={p.pageTitle} sub={p.pageSub} overlineTestId="pricing-page-overline" />
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-16 lg:px-12">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="pricing-grid">
          {p.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <article
                data-testid={`pricing-card-${i}`}
                className={`flex h-full flex-col rounded-3xl border p-7 ${
                  item.highlight ? "border-petrol bg-petrol text-white" : "border-warmline bg-white"
                }`}
              >
                {item.highlight && (
                  <span className="mb-3 inline-flex w-fit rounded-full bg-gold px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-widest text-petrol">
                    Start
                  </span>
                )}
                <h2 className={`font-display text-lg font-semibold leading-snug tracking-tight ${item.highlight ? "text-white" : "text-petrol"}`}>
                  {item.name}
                </h2>
                <p className={`mt-1 text-sm ${item.highlight ? "text-white/65" : "text-slate2"}`}>{item.duration}</p>
                <p className={`mt-5 font-display text-4xl font-semibold tracking-tight ${item.highlight ? "text-gold" : "text-petrol"}`} data-testid={`pricing-price-${i}`}>
                  {item.price}
                </p>
                <p className={`mt-4 flex-1 text-sm leading-relaxed ${item.highlight ? "text-white/75" : "text-slate2"}`}>{item.note}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-8">
          <div className="rounded-3xl border border-gold/40 bg-sand p-6 sm:p-8" data-testid="pricing-notes">
            <ul className="grid gap-3 sm:grid-cols-2">
              {p.notes.map((note, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm text-slate2">
                  <Info className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" />
                  <span>{note}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <div className="mt-12">
          <CtaBand testId="pricing-cta-band" ctaTestId="pricing-whatsapp-cta" />
        </div>
      </div>
    </main>
  );
}
